<template>
    <div class="container-fluid">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-3">
                        <div class="list-group list-group-flush">
                            <h4
                                style="
                                    color: #9c9c9c;
                                    font-weight: normal;
                                    font-size: 20px;
                                "
                            >
                                {{ $t("lang.label_gnrl_setting").toUpperCase() }}
                            </h4>
                            <router-link
                                :to="{ name: 'RestaurantInformation' }"
                                class="list-group-item list-group-item-action"
                                >{{ $t("lang.label_rtrant_info") }}</router-link
                            >
                            <router-link
                                :to="{ name: 'MetaTags' }"
                                class="list-group-item list-group-item-action"
                                >{{ $t("lang.label_mt") }}</router-link
                            >
                            <div
                                class="list-group-item list-group-item-action"
                                @click="ModalBox('templates')"
                            >
                                {{ $t("lang.label_template") }}
                            </div>
                            <div
                                class="list-group-item list-group-item-action"
                                @click="ModalBox('languege')"
                            >
                                {{ $t("lang.label_lang") }}
                            </div>
                            <div
                                class="list-group-item list-group-item-action"
                                @click="ModalBox('currency')"
                            >
                                {{ $t("lang.label_currency") }}
                            </div>
                            <router-link
                                :to="{ name: 'MenuGroup' }"
                                class="list-group-item list-group-item-action"
                                >{{ $t("lang.label_m_g") }}</router-link
                            >
                            <router-link
                                :to="{ name: 'MenuRestore' }"
                                class="list-group-item list-group-item-action"
                                >{{ $t("lang.label_restore") }}</router-link
                            >
                            <div
                                class="list-group-item list-group-item-action"
                                @click="ModalBox('notification')"
                            >
                                {{ $t("lang.label_notifications") }}
                            </div>                                                    
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="list-group list-group-flush">
                            <h4
                                style="
                                    color: #9c9c9c;
                                    font-weight: normal;
                                    font-size: 20px;
                                "
                            >
                                {{ $t("lang.label_mn_wget").toUpperCase() }}
                            </h4>
                            <div
                                class="list-group-item list-group-item-action"
                                @click="ModalBox('widgetcode')"
                            >
                                {{ $t("lang.label_gmc_web") }}
                            </div>
                            <div
                                class="list-group-item list-group-item-action"
                                @click="ModalBox('widgetcodeSpecials')"
                            >
                                {{ $t("lang.label_gmc_webd") }}
                            </div>
                            <div
                                class="list-group-item list-group-item-action"
                                @click="ModalBox('widgetBookTable')"
                            >
                                {{ $t("lang.label_r_m") }}
                            </div>
                        </div>
                    </div>

                    <div class="col-md-3">
                        <div class="list-group list-group-flush">
                            <h4
                                style="
                                    color: #9c9c9c;
                                    font-weight: normal;
                                    font-size: 20px;
                                "
                            >
                                {{ $t("lang.label_mn_wtget").toUpperCase() }}
                            </h4>
                            <div
                                class="list-group-item list-group-item-action"
                                @click="ModalBox('widgetCodeTwo')"
                            >
                                {{ $t("lang.label_gmc_web") }}
                            </div>
                            <!-- <div class="list-group-item list-group-item-action" @click="ModalBox('widgetCodeSpcTwo')">
								{{$t("lang.label_gmc_webd")}}
							</div> -->
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="list-group list-group-flush">
                            <h4
                                style="
                                    color: #9c9c9c;
                                    font-weight: normal;
                                    font-size: 20px;
                                "
                            >
                                Ajustes de diseño
                            </h4>
                            <router-link
                                :to="{ name: 'family' }"
                                class="list-group-item list-group-item-action"
                                >
                                {{$t("lang.label_profile_styles")}}
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <modal name="modal-setting" height="auto" @before-close="ClosedModal">
            <div class="card">
                <button @click="closeModal" class="closeIcon"><span></span></button>
                <component :is="SettingBox"></component>
            </div>
        </modal>
    </div>
</template>
<script>
import Loader from "@/components/shared/Loader.vue";
import widgetcode from "@/components/dimenu/setup/widgetCode.vue";
import widgetCodeTwo from "@/components/dimenu/setup/widgetCodeTwo.vue";
import widgetcodeSpecials from "@/components/dimenu/setup/widgetCodeSpc.vue";
import widgetCodeSpcTwo from "@/components/dimenu/setup/widgetCodeSpcTwo.vue";
import currency from "@/components/dimenu/setup/currency.vue";
import notification from "@/components/dimenu/setup/notification.vue";
import widgetBookTable from "@/components/dimenu/setup/widgetBookTable.vue";
import fontFamily from "@/components/dimenu/setup/fontFamily.vue";
import languege from "@/components/dimenu/setup/languege.vue";
import templates from "@/components/dimenu/setup/templates.vue";
import axios from "axios";
export default {
    name: "Setup",
    components: {
        Loader,
        widgetcode,
        widgetCodeTwo,
        widgetcodeSpecials,
        widgetCodeSpcTwo,
        currency,
        notification,
        widgetBookTable,
        fontFamily,
        languege,
        templates,
    },
    data () {
        return {
            isLoading: false,
            SettingBox: "",
        };
    },
    methods: {
        ModalBox(i) {
            this.SettingBox = i;
            this.$modal.show("modal-setting");
        },
        closeModal() {
            this.$modal.hide("modal-setting");
        },
        ClosedModal() {
            this.SettingBox = "";
        },
    },
    watch: {
        infoSpcl: {
            handler: function (val, oldVal) {
                var t = "";
                t += '<div id="appMenuSpc"></div>';
                t += '<script id="appScriptMenuSpc">';
                t += "var d=document,appMenuSpc=" + window.localuserdata;
                t += ',IdDivSpc="appMenuSpc",IdMenuSpc="widgetSpc",f=new Date,';
                t += 'urlSpc="' + window.urlmaster + "api/widget/appw2/";
                if (this.infoSpcl === 1 && this.infoRes === 0) {
                    t += '?special=on&header=off",';
                } else if (this.infoSpcl === 0 && this.infoRes === 1) {
                    t += '?special=off&header=on",';
                } else if (this.infoSpcl === 1 && this.infoRes === 1) {
                    t += '?special=on&header=on",';
                }
                t +=
                    't=d.querySelector("#appScriptMenuSpc"),s=d.createElement("script");';
                t += 's.type="text/javascript",s.id="widgetMenuSpcScript",';
                t += 's.defer=!0,s.src=urlSpc+appMenuSpc+"/"+f.getTime(),';
                t += "t.parentNode.insertBefore(s,t);";
                // eslint-disable-next-line no-useless-escape
                t += "<\/script>";
                this.uriOrigin = t;
            },
            deep: true,
        },
        infoRes: {
            handler: function (val, oldVal) {
                var t = "";
                t += '<div id="appMenuSpc"></div>';
                t += '<script id="appScriptMenuSpc">';
                t += "var d=document,appMenuSpc=" + window.localuserdata;
                t += ',IdDivSpc="appMenuSpc",IdMenuSpc="widgetSpc",f=new Date,';
                t += 'urlSpc="' + window.urlmaster + "api/widget/appw2/";
                if (this.infoSpcl === 1 && this.infoRes === 0) {
                    t += '?special=on&header=off",';
                } else if (this.infoSpcl === 0 && this.infoRes === 1) {
                    t += '?special=off&header=on",';
                } else if (this.infoSpcl === 1 && this.infoRes === 1) {
                    t += '?special=on&header=on",';
                }
                t +=
                    't=d.querySelector("#appScriptMenuSpc"),s=d.createElement("script");';
                t += 's.type="text/javascript",s.id="widgetMenuSpcScript",';
                t += 's.defer=!0,s.src=urlSpc+appMenuSpc+"/"+f.getTime(),';
                t += "t.parentNode.insertBefore(s,t);";
				// eslint-disable-next-line no-useless-escape
                t += "<\/script>";
                this.uriOrigin = t;
            },
            deep: true,
        },
    },
};
</script>
<style lang="scss" scoped></style>
